import React from 'react';

// Simple wrapper for the authentic uploaded EasyLease logo. The logo file is a
// black-and-gold wordmark on white. On dark backgrounds we render it inside a
// small ivory "logo plate"; on light backgrounds we render it natively.
export const Logo = ({ variant = 'light', className = '' }) => {
  const onDark = variant === 'dark';
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <div className={onDark ? 'bg-ivory-50 px-3 py-1.5 rounded-sm shadow-sm' : ''}>
        <img
          src="/media/brand/easylease-logo.jpg"
          alt="Easylease Global Resources Limited"
          width="150"
          height="42"
          loading="eager"
          className={onDark ? 'h-8 md:h-9 w-auto object-contain' : 'h-10 md:h-11 w-auto object-contain'}
        />
      </div>
    </div>
  );
};

export default Logo;
